(() => {
    if (document.body.classList.contains('page-template-page-tourdates')) {
        new BGShape(document.body);
    }
})();